var exports = {
  "kL": "Slate.module__container___UUlzbX",
  "Qs": "Slate.module__content___UUlzbX",
  "Kt": "Slate.module__iconTextContainer___UUlzbX",
  "Kk": "Slate.module__icon___UUlzbX",
  "FS": "Slate.module__textContainer___UUlzbX",
  "DD": "Slate.module__title___UUlzbX",
  "h_": "Slate.module__description___UUlzbX",
};

module.exports = exports;
